/*
 * HOOPERS print preview — the shirt back with the shopper's name and number, drawn live
 * in the club's own print (font or official glyph artwork, colour, crest in the digits).
 *
 * The snippet (snippets/hoopers-print-preview.liquid) renders only for products whose
 * hoopers.print_preview metafield names a kit in pp-config.json, so every other product
 * is untouched. The card is moved into the buy box's print fields ([data-hup-fields]),
 * which upsells.js shows only while "שם ומספר" is ticked. It reads the same two inputs
 * upsells.js sanitises and never writes to them: pricing and cart properties stay theirs.
 *
 * Geometry is in % of the back image; see the prototype in
 * Downloads/HOOPERS_PRINT_PREVIEW_202609/prototype for where each kit was measured.
 */
(function () {
  if (window.__hppBoot) return;
  window.__hppBoot = 1;

  var NS = 'http://www.w3.org/2000/svg';
  var IMG_FILE = { '.': 'dot', '-': 'dash', "'": 'apos' };
  var DEFAULTS = { nameTracking: 0.06, digitTracking: 0.08, texture: 0.25 };
  var cfgCache = {};
  var fontCache = {};
  var uidSeq = 0;
  var measure = document.createElement('canvas').getContext('2d');

  function loadConfig(url) {
    if (!cfgCache[url]) cfgCache[url] = fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); });
    return cfgCache[url];
  }

  function loadFont(f, base) {
    if (!f.url) return Promise.resolve();
    if (!fontCache[f.family]) {
      var face = new FontFace(f.family, 'url(' + base + f.url + ')');
      fontCache[f.family] = face.load().then(function (loaded) { document.fonts.add(loaded); });
    }
    return fontCache[f.family];
  }

  function pin(node, family) {
    node.style.setProperty('font-family', family, 'important');
    node.style.setProperty('font-weight', 'normal', 'important');
    node.style.setProperty('letter-spacing', '0', 'important');
    return node;
  }

  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  // Same limits the print field enforces: A-Z and space, up to 12; numbers 1-99.
  function cleanName(raw) {
    return String(raw || '').toUpperCase().replace(/[^A-Z .'-]/g, '').replace(/ {2,}/g, ' ').replace(/^[ .'-]+/, '').slice(0, 12).replace(/ +$/, '');
  }
  function cleanNum(raw) {
    var d = String(raw || '').replace(/[^0-9]/g, '').replace(/^0+/, '').slice(0, 2);
    return d && +d >= 1 && +d <= 99 ? d : '';
  }

  function Preview(box, cfg, kit, base) {
    this.box = box;
    this.base = base;
    this.CFG = Object.assign({}, DEFAULTS, JSON.parse(JSON.stringify(kit)));
    this.FONT_NUM = cfg.fonts[this.CFG.font];
    this.FONT_NAME = cfg.fonts[this.CFG.nameFont || this.CFG.font];
    this.FONT = this.FONT_NUM;
    this.uid = 'hpp' + (++uidSeq);
    this.img = box.querySelector('[data-hpp-back]');
    this.svg = box.querySelector('[data-hpp-svg]');
  }

  Preview.prototype.fontCss = function (px) {
    return (this.FONT.url ? 'normal ' : '600 ') + px + 'px "' + this.FONT.family + '"';
  };
  Preview.prototype.layout = function (str, size, tracking, stretch) {
    var self = this;
    measure.font = this.fontCss(size);
    var adv = str.split('').map(function (ch) { return measure.measureText(self.FONT.charMap[ch] || ch).width * stretch; });
    var gap = tracking * size;
    var total = adv.reduce(function (a, b) { return a + b; }, 0) + gap * Math.max(0, adv.length - 1);
    return { adv: adv, gap: gap, total: total };
  };
  Preview.prototype.capRatio = function (isNum) {
    measure.font = this.fontCss(100);
    return measure.measureText(isNum ? '0' : 'H').actualBoundingBoxAscent / 100;
  };
  Preview.prototype.fit = function (str, box, W, H, tracking, isNum) {
    var size = (box.h / 100 * H) / this.capRatio(isNum);
    var st = box.stretch || 1;
    var L = this.layout(str, size, tracking, st);
    var maxW = box.w / 100 * W;
    if (L.total > maxW) { size *= maxW / L.total; L = this.layout(str, size, tracking, st); }
    return { size: size, L: L };
  };

  // Clubs that publish each printed character as artwork: draw the images as-is.
  Preview.prototype.drawImages = function (str, box, tracking, W, H, group) {
    var I = box.images, cap = I.cap || 1, h = box.h / 100 * H, sp = 0.3 * h, base = this.base;
    var chars = str.split('');
    var ws = chars.map(function (ch) { return ch === ' ' ? sp : h * (I.ratio[IMG_FILE[ch] || ch] || 0.6); });
    var gap = tracking * h;
    var total = ws.reduce(function (a, b) { return a + b; }, 0) + gap * (ws.length - 1);
    var k = Math.min(1, (box.w / 100 * W) / total), hh = h * k;
    total *= k;
    var cx = box.x / 100 * W, baseline = (box.y + box.h) / 100 * H;
    var R = box.arc ? box.arc * (this.CFG.number.h / 100 * H) : 0;
    var x = cx - total / 2;
    chars.forEach(function (ch, i) {
      var w = ws[i] * k;
      if (ch !== ' ') {
        var mid = x + w / 2, th = R ? (mid - cx) / R : 0;
        var px = R ? cx + R * Math.sin(th) : mid, py = R ? baseline + R * (1 - Math.cos(th)) : baseline;
        var wrap = el('g', { transform: 'translate(' + px + ' ' + py + ') rotate(' + (th * 180 / Math.PI) + ')' }, group);
        el('image', { href: base + I.base + (IMG_FILE[ch] || ch) + '.png', x: -w / 2, y: -hh, width: w, height: hh / cap, preserveAspectRatio: 'none' }, wrap);
      }
      x += w + gap * k;
    });
    return [];
  };

  Preview.prototype.drawLine = function (str, box, tracking, W, H, group, mask, isNum, numMask) {
    this.FONT = isNum ? this.FONT_NUM : this.FONT_NAME;
    if (box.images) return this.drawImages(str, box, tracking, W, H, group);
    var self = this, F = this.FONT, CFG = this.CFG;
    var fit = this.fit(str, box, W, H, tracking, isNum), size = fit.size, L = fit.L;
    var baseline = (box.y + box.h) / 100 * H, cx = box.x / 100 * W;
    var R = box.arc ? box.arc * (CFG.number.h / 100 * H) : 0;
    var st = box.stretch || 1;
    var x = cx - L.total / 2, glyphs = [];
    str.split('').forEach(function (ch, i) {
      var out = F.charMap[ch] || ch, mid = x + L.adv[i] / 2;
      var px = mid, py = baseline, rot = 0;
      if (R) { var th = (mid - cx) / R; px = cx + R * Math.sin(th); py = baseline + R * (1 - Math.cos(th)); rot = th * 180 / Math.PI; }
      var attrs = { x: 0, y: 0, 'text-anchor': 'middle', 'font-family': "'" + F.family + "'", 'font-size': size };
      if (!F.url) attrs['font-weight'] = 600;
      var tr = 'translate(' + px + ' ' + py + ') rotate(' + rot + ') scale(' + st + ' 1)';
      var t = el('text', Object.assign({ fill: CFG.fill }, attrs), el('g', { transform: tr }, group));
      if (box.outline) {
        t.setAttribute('stroke', box.outline.color);
        t.setAttribute('stroke-width', box.outline.width * size / Math.sqrt(st));
        t.setAttribute('paint-order', 'stroke');
        t.setAttribute('stroke-linejoin', 'miter');
      }
      t.textContent = out;
      // The theme forces "Noto Sans Hebrew" !important on text; only an inline !important beats it.
      var ff = "'" + F.family + "'";
      pin(t, ff);
      pin(el('text', Object.assign({ fill: '#fff' }, attrs), el('g', { transform: tr }, mask)), ff).textContent = out;
      if (numMask) pin(el('text', Object.assign({ fill: '#fff' }, attrs), el('g', { transform: tr }, numMask)), ff).textContent = out;
      measure.font = self.fontCss(size);
      var m = measure.measureText(out), o = px - L.adv[i] / 2;
      t._ink = { x: o - m.actualBoundingBoxLeft * st, y: py - m.actualBoundingBoxAscent,
                 width: (m.actualBoundingBoxLeft + m.actualBoundingBoxRight) * st, height: m.actualBoundingBoxAscent + m.actualBoundingBoxDescent };
      glyphs.push(t);
      x += L.adv[i] + L.gap;
    });
    return glyphs;
  };

  Preview.prototype.drawBadge = function (glyphs, badge, group, defs) {
    if (!badge || !badge.src || !glyphs.length) return;
    var filter = null, id;
    if (badge.style === 'engrave') {
      id = this.uid + '-engrave';
      var f = el('filter', { id: id, 'color-interpolation-filters': 'sRGB' }, defs);
      el('feColorMatrix', { type: 'saturate', values: '0' }, f);
      var tr = el('feComponentTransfer', {}, f);
      ['R', 'G', 'B'].forEach(function (c) { el('feFunc' + c, { type: 'linear', slope: 1.9, intercept: -0.12 }, tr); });
      filter = 'url(#' + id + ')';
    } else if (badge.tint) {
      id = this.uid + '-tint';
      var f2 = el('filter', { id: id, 'color-interpolation-filters': 'sRGB' }, defs);
      el('feFlood', { 'flood-color': badge.tint }, f2);
      el('feComposite', { in2: 'SourceAlpha', operator: 'in' }, f2);
      filter = 'url(#' + id + ')';
    }
    var boxes = glyphs.map(function (g) { return g._ink; });
    var targets = badge.anchor === 'first' ? [boxes[0]] : badge.anchor === 'last' ? [boxes[boxes.length - 1]] : boxes;
    var src = this.base + badge.src;
    targets.forEach(function (b, i) {
      var ch = badge.anchor === 'each' ? glyphs[i].textContent : null;
      var p = (badge.perDigit && ch && badge.perDigit[ch]) || badge;
      var w = b.width * p.w;
      var im = el('image', { href: src, x: b.x + b.width * p.x - w / 2, y: b.y + b.height * p.y - w / 2, width: w, height: w, preserveAspectRatio: 'xMidYMid meet' }, group);
      if (filter) im.setAttribute('filter', filter);
      if (badge.style === 'engrave') im.style.mixBlendMode = 'multiply';
    });
  };

  Preview.prototype.render = function (rawName, rawNum) {
    var img = this.img, svg = this.svg, CFG = this.CFG, uid = this.uid;
    var W = img.naturalWidth, H = img.naturalHeight;
    if (!W) return;
    var name = cleanName(rawName), num = cleanNum(rawNum);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    this.box.classList.toggle('hpp--empty', !name && !num);

    var defs = el('defs', {}, svg);
    var mask = el('mask', { id: uid + '-pm' }, defs);
    var group = el('g', {}, svg);
    if (name) this.drawLine(name, CFG.name, CFG.nameTracking, W, H, group, mask, false, null);
    var nm = el('mask', { id: uid + '-nm' }, defs);
    var numGlyphs = num ? this.drawLine(num, CFG.number, CFG.digitTracking, W, H, group, mask, true, nm) : [];

    if (num && CFG.number.inline && !CFG.number.images) {
      var inl = CFG.number.inline, ink = el('g', { mask: 'url(#' + uid + '-nm)' }, group);
      var first = nm.querySelector('text');
      var size = first ? +first.getAttribute('font-size') : 0;
      inl.lines.slice().sort(function (a, b) { return b - a; }).forEach(function (dist) {
        [[2 * (dist + inl.t) * size, inl.color], [2 * dist * size, CFG.fill]].forEach(function (pair) {
          Array.prototype.forEach.call(nm.children, function (src) {
            var g2 = src.cloneNode(true), tx = g2.firstChild;
            tx.setAttribute('fill', 'none'); tx.setAttribute('stroke', pair[1]);
            tx.setAttribute('stroke-width', pair[0]); tx.setAttribute('stroke-linejoin', 'round');
            ink.appendChild(g2);
          });
        });
      });
    }
    if (num && CFG.number.dots && !CFG.number.images) {
      var pitch = W * (CFG.number.dotPitch || 0.0065), pat = el('pattern', { id: uid + '-dots', width: pitch, height: pitch, patternUnits: 'userSpaceOnUse' }, defs);
      el('circle', { cx: pitch / 2, cy: pitch / 2, r: pitch * 0.22, fill: '#000' }, pat);
      el('rect', { x: 0, y: 0, width: W, height: H, fill: 'url(#' + uid + '-dots)', mask: 'url(#' + uid + '-nm)', opacity: CFG.number.dots }, group);
    }
    this.drawBadge(numGlyphs, CFG.number.badge, group, defs);
    // Fabric shading over font-drawn print (image glyphs carry their own).
    el('image', { href: img.currentSrc || img.src, x: 0, y: 0, width: W, height: H, mask: 'url(#' + uid + '-pm)', style: 'mix-blend-mode:overlay;opacity:' + CFG.texture }, svg);
    svg.setAttribute('aria-label', [name, num].filter(Boolean).join(' ') || 'תצוגת הגב');
  };

  function init(box) {
    if (box.__hpp) return;
    box.__hpp = 1;
    var key = box.getAttribute('data-hpp');
    var base = box.getAttribute('data-hpp-base');
    var cfgUrl = box.getAttribute('data-hpp-config');

    function hup() {
      var f = box.closest('form');
      return (f && f.querySelector('[data-hup]')) || document.querySelector('[data-hup]');
    }
    function q(sel) { var r = hup(); return r ? r.querySelector(sel) : null; }

    loadConfig(cfgUrl).then(function (cfg) {
      var kit = cfg.kits[key];
      if (!kit) return;
      var pv = new Preview(box, cfg, kit, base);
      var fontReady = Promise.all([loadFont(pv.FONT_NUM, base), loadFont(pv.FONT_NAME, base)]);
      var imgReady = new Promise(function (res) {
        pv.img.onload = res;
        pv.img.onerror = res;
        pv.img.src = base + kit.back;
        if (pv.img.complete && pv.img.naturalWidth) res();
      });

      function draw() {
        var n = q('[data-hup-name]'), d = q('[data-hup-num]');
        pv.render(n ? n.value : '', d ? d.value : '');
      }

      // Into the print fields, above the player chips. Chips place themselves at the
      // top too, so the card re-asserts first place whenever the box changes.
      var fieldsSeen = null;
      function place() {
        var fields = q('[data-hup-fields]');
        if (!fields) return false;
        if (fields.firstChild !== box) fields.insertBefore(box, fields.firstChild);
        box.hidden = false;
        if (fieldsSeen !== fields) {
          fieldsSeen = fields;
          new MutationObserver(function () { if (fields.firstChild !== box) fields.insertBefore(box, fields.firstChild); })
            .observe(fields, { childList: true });
          var n = q('[data-hup-name]'), d = q('[data-hup-num]');
          [n, d].forEach(function (inp) {
            if (!inp) return;
            inp.addEventListener('input', draw);
            inp.addEventListener('change', draw);
            inp.addEventListener('blur', draw);
          });
          var root = hup();
          if (root) root.addEventListener('change', draw);
        }
        return true;
      }

      Promise.all([fontReady.catch(function () {}), imgReady]).then(function () {
        var W = pv.img.naturalWidth, H = pv.img.naturalHeight;
        // The card shows the back from 4% down to just below the print; kits that carry
        // the name under the number (Bundesliga) need a taller window.
        var low = Math.max(kit.name ? kit.name.y + kit.name.h : 0, kit.number ? kit.number.y + kit.number.h : 0);
        var vis = Math.max(0.66, Math.min(0.92, (low + 5 - 4) / 100));
        if (W && H) box.style.setProperty('--hpp-ratio', W + ' / ' + (H * vis).toFixed(1));
        if (!place()) {
          var obs = new MutationObserver(function () { if (place()) { obs.disconnect(); draw(); } });
          obs.observe(document.body, { childList: true, subtree: true });
          setTimeout(function () { obs.disconnect(); }, 20000);
        }
        draw();
      });
    }).catch(function () { /* no config: stay hidden, buy box unchanged */ });
  }

  function scan() {
    var list = document.querySelectorAll('[data-hpp]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  scan();
  document.addEventListener('shopify:section:load', scan);
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          var n = a[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-hpp') || n.querySelector('[data-hpp]'))) { scan(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
